import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

/** `tyre.manage` shows the controls that change a tyre; the server stays the authority, so this is UX only. */
export function useCanManageTyres(): boolean {
  const { state } = useCurrentUser();
  return state.status === 'authenticated' && state.user.permissions.includes('tyre.manage');
}
